import { DataTable } from '@/components/ui/data-table'
import type { AccountDetailResponse, AuditEntry } from '@/lib/types'

interface AuditTabProps {
  account: AccountDetailResponse
}

export function AuditTab({ account }: AuditTabProps): React.JSX.Element {
  const columns = [
    {
      key: 'created_at',
      label: 'Timestamp',
      sortable: true,
      render: (row: AuditEntry) => (
        <span className="font-mono text-xs">{new Date(row.created_at).toLocaleString()}</span>
      ),
    },
    {
      key: 'admin_email',
      label: 'Admin',
      render: (row: AuditEntry) => <span className="text-text-secondary">{row.admin_email}</span>,
    },
    {
      key: 'action',
      label: 'Action',
      render: (row: AuditEntry) => (
        <span className="rounded bg-surface-2 px-2 py-0.5 font-mono text-xs">{row.action}</span>
      ),
    },
    {
      key: 'details',
      label: 'Details',
      render: (row: AuditEntry) => (
        <span className="max-w-[300px] truncate text-xs text-text-tertiary">
          {row.details ? JSON.stringify(row.details) : '-'}
        </span>
      ),
    },
  ]

  return (
    <DataTable
      columns={columns}
      data={account.audit_log}
      emptyMessage="No admin actions recorded for this account."
    />
  )
}
